


























import { Component, Vue } from "vue-property-decorator";
import { deleteContract } from "@/services/contracts/contractService";

@Component
export default class ContractDeleteModal extends Vue {
    contractToBeDeleted: string = "";
    contractName: string = ""

    open(contractId: string, name: string) {
        this.contractToBeDeleted = contractId;
        this.contractName = name;
        this.$bvModal.show("modal-deleteContract");
    }

    decline() {
        this.$bvModal.hide("modal-deleteContract");
        this.contractName = "";
        this.contractToBeDeleted = "";
    }

    confirm() {
        this.$bvModal.hide("modal-deleteContract");
        deleteContract(this.contractToBeDeleted).then(() => {
            this.$emit("reload");
        });
        this.contractName = "";
        this.contractToBeDeleted = "";
    }
}
